export enum AppointmentStatus {
    Pending = 0,
    Confirmed = 1,
    Declined = 2,
    Shown = 3
}